/* @flow weak */
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import './styles/Columns2.scss';

class Columns2 extends React.Component {
  static propTypes = {
    direction: React.PropTypes.oneOf(['right', 'left']),
    gutter: React.PropTypes.oneOf(['xlarge', 'medium', 'small', 'xsmall', 'xxsmall']),
    reset: React.PropTypes.oneOf(['tablet']),
    flex: React.PropTypes.bool,
  };

  static propClasses = {
    direction: {
      left: 'Columns2--rev',
    },
    gutter: {
      xlarge: 'Columns2--xloose',
      small: 'Columns2--tight',
      xsmall: 'Columns2--xtight',
      xxsmall: 'Columns2--xxtight',
    },
    reset: {
      tablet: 'Columns2--reset--tablet',
    },
    flex: 'Columns2--flex',
  };

  static defaultProps = {
    direction: 'right',
    gutter: 'medium',
  };

  wrap = (node) => {
    return <div className="Columns2-column Columns2-column1-2">{node}</div>;
  };

  render() {
    const children = React.Children.map(this.props.children, function(child, index) {
      return (
        <div className="Columns2-column Columns2-column1-2" key={index}>{child}</div>
      );
    });

    return (
      <div className={cx('Columns2', getPropClassesFromInstance(this), this.props.className)}>
        {children}
      </div>
    );
  }
}

export default Columns2;



// WEBPACK FOOTER //
// ./src/components/Columns2.jsx